import UserSignupStateDefinition from './UserSignupStateDefinition';

function userSignupReducer(
  state = UserSignupStateDefinition.getInitialState()
) {
  return state;
}

export default userSignupReducer;
